import React, { useContext } from 'react';
import { StatusContext } from '../context/Status';

const Footer = () => {
  const [statusState] = useContext(StatusContext);
  let cachedVersion = '';
  try {
    cachedVersion =
      JSON.parse(localStorage.getItem('status') || '{}')?.version || '';
  } catch (_) {
    cachedVersion = '';
  }
  const version =
    statusState?.status?.version ||
    process.env.REACT_APP_VERSION ||
    cachedVersion;

  return version ? (
    <footer className='app-version-footer-v8' aria-label='Application version'>
      <span className='app-version-footer-v8__product'>AlfredAPI</span>{' '}
      <span className='app-version-footer-v8__version'>{version}</span>
    </footer>
  ) : null;
};

export default Footer;
